import FSCss from "../../css/overview.module.css";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { ReactComponent as DeleteIcon } from "../../../myfin_v2/assets/icons/delete_icon_primary.svg";
import { ReactComponent as SearchIcon } from "../../../myfin_v2/assets/icons/searchPri.svg";
import buttoncss from "../../../myfin_v2/css/button.module.css";
import { Button } from "../../../myfin_v2/elements/Button";
import NoteSoftDelete from "../../../Components/templateTabs/NoteSoftDelete/softDelete";
import RestoreSoftDelete from "../../../Components/templateTabs/NoteSoftDelete/restoreSoftDelete";

const FSTopBar = ({ history, consolID, prepopulate = false }) => {
  return (
    <div className={FSCss.w100}  style={{paddingRight: "25px"}} >
      <div className={FSCss.uploadLoansMainContainer}></div>

      <div className={FSCss.listPageheader}>
        <div className={FSCss.headerLeftContainer}>
          <div className={FSCss.iconContainer}></div>
        </div>
        <div className={FSCss.headerRightContainer}>
          &ensp;
          {prepopulate ? (
            <Button
              btnColor={buttoncss.primary}
              label="Populate FS"
              style={{ paddingLeft: "20px" }}
              onClick={() => {
                history.push(`/myfinV2/console-populatefs/${consolID}`);
              }}
            />
          ) : (
            <Button
              btnColor={buttoncss.primary}
              label="Finalise FS"
              onClick={() => {
                history.push(`/consol/finalize-fs/${consolID}`);
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default FSTopBar;
